import { Outlet, useLocation } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { Sidebar } from '../components/dashboard/Sidebar';
import { Topbar } from '../components/dashboard/Topbar';
import { findNavigationItem, getDashboardNavigation } from '../components/dashboard/navigation';
import { useTenant } from '../hooks/useTenant';

export function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { activeTenant } = useTenant();

  const navigation = useMemo(() => getDashboardNavigation(activeTenant?.type), [activeTenant?.type]);

  const title = useMemo(() => {
    if (location.pathname.startsWith('/dashboard/courses/')) return 'Course';
    if (location.pathname.startsWith('/view-student')) return 'View Student';
    if (location.pathname.startsWith('/dashboard/applications/')) return 'View Student';
    if (location.pathname.startsWith('/dashboard/finance/invoices/')) return 'Invoice';
    if (location.pathname.startsWith('/dashboard/finance/invoices')) return 'Invoices';
    if (location.pathname.startsWith('/dashboard/finance/fee-balances')) return 'Fee Balances';
    if (location.pathname.startsWith('/dashboard/finance/school-fee-income/') && location.pathname.includes('/receipt')) return 'School Fee Receipt';
    if (location.pathname.startsWith('/dashboard/finance/school-fee-income')) return 'School Fee Income';
    if (location.pathname.startsWith('/dashboard/hr/payroll/payment-ledger')) return 'Payment Ledger';
    if (location.pathname.startsWith('/dashboard/hr/payroll/pay-salaries')) return 'Pay Salaries';
    if (location.pathname.startsWith('/dashboard/hr/payroll')) return 'Payroll';
    const match = findNavigationItem(location.pathname, navigation);
    return match?.label || 'Dashboard';
  }, [location.pathname, navigation]);

  return (
    <div className="dashboard-layout">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <div className="dashboard-main">
        <Topbar title={title} navigationOpen={open} onMenuClick={() => setOpen((value) => !value)} />
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
